import { createSelector } from "reselect";
import { memoize, uniqueByKey } from "@ls/js-utils";
import SelectionState from "state/selections/SelectionState";
import scope from "./scope";

export const selectFetchingCashFlowData = (state) =>
  state[scope].fetchingCashFlowData;
export const selectCashFlowData = (state) => state[scope].cashFlowData;
export const selectPeriodOptions = (state) => state[scope].periodOptions;
export const selectTypeOptions = (state) => state[scope].typeOptions;

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});
